export const parseConfigString  = (code, fallback) => window.OPSEEKER_CONFIG[code] ? window.OPSEEKER_CONFIG[code] : fallback;